export const isValidGatedContentPassword = (password: string): boolean => {
    const trimmedPassword = password?.trim();
    return trimmedPassword?.length > 0 && password.length <= 256;
};
